import React, { useState,useEffect } from 'react';
import Icon from '../../icons';

const FormSelect = (field) => {
const[value,setvalue]=useState(field.selected);
const[isAssignMe,setAssignMe]=useState(false);
 
 useEffect(() => {
    if(field.creationForm && field.creationForm =="activity"){
        if(field.options && field.selected && field.selected!="Default"){
            const temp=field.options.filter(t=>t.label==field.selected);
            if(temp.length)
                setvalue(temp[0].value);
        }
        else if(field.selected && field.selected =="Default"){
            setvalue(field.selected);
        }
    }
    else if(field.type && field.type=="country"){
        setvalue(field.selected);
    }
}, []);

useEffect(()=>{
    if(field.selected!=undefined && field.selected!=null && field.selected!=""){
        setvalue(field.selected);
        const assign= field.options.filter(e=>e.DisplayName==field.assignMe);
        if(assign.length && field.selected==assign[0].UserId){
            setAssignMe(!isAssignMe);
        }
    }
},[field.selected])

const changeTemplate=(e)=>{
    setvalue(e.target.value);
    field.input.onChange(e.target.value);
    if(field.SelectedTemplate){
    field.changeSelectedTemplate(e.target.value);
    }
    if(field.type && field.type=="country"){
    field.setDefaultLocationValue(e.target.value);
    }
    if(field.assignMe){
     const assign= field.options.filter(e=>e.DisplayName==field.assignMe);
     if(e.target.value==assign[0].UserId){
        setAssignMe(!isAssignMe);
     }
     else{
        if(isAssignMe){
            setAssignMe(!isAssignMe);
        }
     }
    }

}

const assignToMe=()=>{
   const assign= field.options.filter(e=>e.DisplayName==field.assignMe);
   if(assign.length){
    field.input.onChange(assign[0].UserId);
     setvalue(assign[0].UserId);
     setAssignMe(!isAssignMe);
   }
}


return(
    <div className={`${field.wrapperClass ? field.wrapperClass : ''} ${(field.meta.touched && field.meta.error) ? 'errorMsg' : ''}`}>
        {field.label && <div className={`${field.labeldivclass}`}><label className={`${field.labelClass ? field.labelClass : ''} `}>{field.label}{field.isRequired && <sup>*</sup>}
            {field.helpText && <span className="quickTooltip-bottom" data-quicktooltip={field.helpText}><Icon name="info" className="icon ml greyInfoIcon" /></span>}
        </label></div>}
        <div className={`${field.divClass ? field.divClass : ''} `}>
            <select {...field.input} value={value} onChange={changeTemplate} disabled={field.isDisabled ?true :false} className={`${field.inputClass ? field.inputClass : ''} ${field.isDisabled ?"disabled":""} `}>
            {field.SelectedTemplate && <option value="Default">Default</option>}
            {field.assignMe && <option value="0">Select Activity Owner</option>}

                {field.options.map((option, i) => (
                    <option key={i} value={option[field.valueKey] || option.value || option.Item1} selected={(value==(option[field.valueKey] || option.value || option.Item1)) || field.options[0].value}>{option[field.labelKey] || option.label || option.Item2 }</option>
                ))}
            </select>
            {field.meta.touched && field.meta.error &&
                <span>{field.meta.error}</span>}  
        </div>
       {field.label == "Activity Owner" ?<em className="ml mt"><a className={`pointer ${field.isDisabled || isAssignMe ? "disabled" : "" }`} onClick={assignToMe}>Make me the owner</a></em>:null}
    </div>
)
            }

export default FormSelect;